import { useMemo } from "react";

const useSetCurrentPage = (page, selectedPageIndex) => {
  const result = useMemo(() => {
    if (selectedPageIndex.length > 0 && page.length > 0) {
      let depth = 1;
      let newPage = page[selectedPageIndex[0]];
      while (depth < selectedPageIndex.length) {
        newPage = newPage.subpages[selectedPageIndex[depth]];
        depth += 1;
      }
      return newPage;
    } else {
      return null;
    }
  }, [page, selectedPageIndex]);
  return result;
};

const useGetCurrentPageName = (page, selectedPageIndex) => {
  const result = useMemo(() => {
    if (selectedPageIndex.length > 0 && page.length > 0) {
      let depth = 1;
      let newPage = page[selectedPageIndex[0]];
      let pageName = page[selectedPageIndex[0]].page;
      while (depth < selectedPageIndex.length) {
        pageName = pageName + " - " + newPage.subpages[selectedPageIndex[depth]].page;
        newPage = newPage.subpages[selectedPageIndex[depth]];
        depth += 1;
      }
      return pageName;
    }
  }, [page, selectedPageIndex]);
  return result;
};

export { useSetCurrentPage, useGetCurrentPageName };
